import { t } from 'i18next';

import { SelectionBase } from './SelectionBase';
import { ProjectSettingsStore } from '../stores/ProjectSettingsStore';
import { ProjectSettingsActions } from '../actions/ProjectSettingsActions';
import { PropertyEditorActions } from '../actions/PropertyEditorActions';
import { SessionActions } from '../actions/SessionActions';
import { CatalogActions } from '../actions/CatalogActions';
import { SelectBoxOption } from '../stores/SelectBoxStore';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';

export class SelectionDataLanguage extends SelectionBase {
    protected showValueInApp: boolean = true;
    protected id: string = 'data-language-select';

    public componentWillMount(): void {
        this.addStoreListener(ProjectSettingsStore, this.onChange);
        this.onChange();
    }

    protected onChange = (): void => {
        this.setState({
            value: ProjectSettingsStore.getState().dataLanguage,
            enabled: true,
            visible: true
        });
    };

    protected setDataLanguage(pValue: string): void {
        if (ProjectSettingsStore.getState().dataLanguage !== pValue) {
            ProjectSettingsActions.setDataLanguage(pValue);
            PropertyEditorActions.onPropertyClick(null);
            SessionActions.setLanguage(pValue, true).then(() => {
                CatalogActions.refreshCatalog();
            });
        }
    }

    protected getLabel(): string {
        return t('Article Language');
    }

    protected options(): Array<SelectBoxOption> {
        return [
            {key: 'cz', name: t('Czech'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('cz'); }},
            {key: 'da', name: t('Danish'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('da'); }},
            {key: 'nl', name: t('Dutch'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('nl'); }},
            {key: 'en', name: t('English'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('en'); }},
            {key: 'fr', name: t('French'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('fr'); }},
            {key: 'de', name: t('German'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('de'); }},
            {key: 'it', name: t('Italian'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('it'); }},
            {key: 'no', name: t('Norwegian'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('no'); }},
            {key: 'pl', name: t('Polish'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('pl'); }},
            {key: 'pt', name: t('Portuguese'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('pt'); }},
            {key: 'ru', name: t('Russian'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('ru'); }},
            {key: 'ro', name: t('Romanian'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('ro'); }},
            {key: 'es', name: t('Spanish'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('es'); }},
            {key: 'sw', name: t('Swedish'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('sw'); }},
            {key: 'tr', name: t('Turkish'), className: 'egr-select-option-noicon', callback: () => {this.setDataLanguage('tr'); }},
        ].filter(
            (option) => {return AppConfigurationStore.dataLanguageFilter(option.key); }
        ).sort(
            (a: SelectBoxOption, b: SelectBoxOption) => {return a.name > b.name ? 1 : -1; }
        );
    }}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SelectionDataLanguage.tsx